<p>view-load works!</p>
